import _ from 'lodash';

export const extractBillingData = profileData => {
  const fields = [
    'billing_full_name',
    'billing_company_name',
    'billing_address_line',
    'billing_city',
    'billing_postcode'
  ];

  return _.pick(profileData, fields);
};
